import script from "./Selector.vue?vue&type=script&setup=true&lang=ts"
export * from "./Selector.vue?vue&type=script&setup=true&lang=ts"

import "./Selector.vue?vue&type=style&index=0&id=8dd76fb4&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dd76fb4"]])

export default __exports__